/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const alignRight = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M11.1 19.8H20v-1.5h-8.9v1.5zm0-15.6v1.5H20V4.2h-8.9zM4 12.8h16v-1.5H4v1.5z" />
	</SVG>
);

export default alignRight;
